import type { Product } from '@/entities/product'
import type { ProductType } from '@/shared/lib/product-type'

const VIEW_HISTORY_KEY = 'tea_catalog_view_history'
const MAX_HISTORY_ITEMS = 10

export interface ViewHistoryItem {
  productId: string
  productType: ProductType
  productName: string
  productImage?: string
  viewedAt: number // timestamp
}

/**
 * Получить историю просмотров из localStorage
 */
export function getViewHistory(): ViewHistoryItem[] {
  if (typeof window === 'undefined') return []
  
  try {
    const stored = localStorage.getItem(VIEW_HISTORY_KEY)
    if (!stored) return []
    
    const history = JSON.parse(stored) as ViewHistoryItem[]
    // Сортируем по дате просмотра (новые первыми)
    return history.sort((a, b) => b.viewedAt - a.viewedAt)
  } catch {
    return []
  }
}

/**
 * Добавить товар в историю просмотров
 */
export function addToViewHistory(product: Product, productType: ProductType): void {
  if (typeof window === 'undefined') return
  
  try {
    const history = getViewHistory()
    
    // Удаляем товар, если он уже есть в истории
    const filteredHistory = history.filter(item => item.productId !== product.id)
    
    // Добавляем новый товар в начало
    const newItem: ViewHistoryItem = {
      productId: product.id,
      productType,
      productName: product.name,
      productImage: product.images?.[0]?.url,
      viewedAt: Date.now(),
    }
    
    const updatedHistory = [newItem, ...filteredHistory].slice(0, MAX_HISTORY_ITEMS)
    
    localStorage.setItem(VIEW_HISTORY_KEY, JSON.stringify(updatedHistory))
  } catch (error) {
    console.error('Failed to save view history:', error)
  }
}

/**
 * Получить недавно просмотренные товары для конкретного типа
 */
export function getRecentViews(productType: ProductType, limit: number = 5): ViewHistoryItem[] {
  const history = getViewHistory()
  return history
    .filter(item => item.productType === productType)
    .slice(0, limit)
}

/**
 * Очистить историю просмотров
 */
export function clearViewHistory(): void {
  if (typeof window === 'undefined') return
  localStorage.removeItem(VIEW_HISTORY_KEY)
}











